import React, { useState, useEffect } from 'react';
import { useFormik } from "formik"
import * as Yup from "yup"
import {
  Button,
  Card,
  CardBody,
  addToast
} from '@heroui/react';
import { Input } from "src/shared/components/Input";
import { 
  GoogleReCaptchaProvider, 
  useGoogleReCaptcha 
} from 'react-google-recaptcha-v3';

import { verify_recaptcha_token } from "src/services/api/verifiers/verifiers_requests";
import { useSendContactMutation } from "src/services/rtk_api/contact/contactApi";

const MainContent = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [sendContact] = useSendContactMutation();

  const formik = useFormik({
    initialValues: {
      email: '',
      first_name: '',
      last_name: '',
      phone_number: '',
      message: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Required"),
      first_name: Yup.string().required("Required"),
      last_name: Yup.string().required("Required"),
      phone_number: Yup.string().required("Required"),
      message: Yup.string().required("Required"),
    }),
    onSubmit: async (values) => {
      if (!executeRecaptcha) return;

      const recaptcha_token = await executeRecaptcha('ContactUsPageForm');
      verify_recaptcha_token(recaptcha_token).then(async (response) => {
        if (response.success) {
          try {
            await sendContact(values).unwrap();
            addToast({
              title: "Email sent successfully!",
              severity: "success",
              color: "success"
            });
            formik.resetForm();
          } catch (err) {
            addToast({
              title: "Failed to send message",
              severity: "danger",
              color: "danger"
            });
          }
        } else {
          addToast({
            title: 'Recaptcha verification failed',
            severity: "danger",
            color: "danger"
          });
        }
      });
    }
  });

  // const handleFormSubmit = async (e) => {
  //   e.preventDefault();
  //   if (form.getFieldsError().filter(({errors}) => errors.length).length > 0) {
  //     message.error('Please fix all errors before submitting the form');
  //     return;
  //   }
  //
  //   const values = form.getFieldsValue();
  //   console.log(values)
  // }

  return (
    <div id="contact-us">
      <div className="container">
        <Card className='card-block max-w-md'>
          <CardBody className="px-7 py-10">
            <span className='contact-us-title'>Contact Us</span>
            <h3 className='title my-1'>Let’s talk how to create <br />and manage a Bill of Materials</h3>
            <span className='subtitle'>Leave us a message</span>
            <form
              className='mt-6'
              onSubmit={formik.handleSubmit}
              name="basic"
              autoComplete="off"
            >
              <div className="grid grid-cols-2 gap-4">
                <div className="col-span-2">
                  <Input
                    variant="bordered"
                    label="Business Email"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={formik.touched.email && !!formik.errors.email}
                    errorMessage={formik.touched.email && formik.errors.email}
                    {...formik.getFieldProps('email')}
                  />
                </div>
                <div>
                  <Input
                    variant="bordered"
                    label="First Name"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={formik.touched.first_name && !!formik.errors.first_name}
                    errorMessage={formik.touched.first_name && formik.errors.first_name}
                    {...formik.getFieldProps('first_name')}
                  />
                </div>
                <div>
                  <Input
                    variant="bordered"
                    label="Last Name"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={formik.touched.last_name && !!formik.errors.last_name}
                    errorMessage={formik.touched.last_name && formik.errors.last_name}
                    {...formik.getFieldProps('last_name')}
                  />
                </div>
                <div className="col-span-2">
                  <Input
                    variant="bordered"
                    label="Phone Number"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={formik.touched.phone_number && !!formik.errors.phone_number}
                    errorMessage={formik.touched.phone_number && formik.errors.phone_number}
                    {...formik.getFieldProps('phone_number')}
                  />
                </div>
                <div className="col-span-2">
                  <Input
                    variant="bordered"
                    label="Message"
                    placeholder=" "
                    labelPlacement="outside"
                    isInvalid={formik.touched.message && !!formik.errors.message}
                    errorMessage={formik.touched.message && formik.errors.message}
                    {...formik.getFieldProps('message')}
                  />
                </div>
                <div className="col-span-2 text-right">
                  <Button color="default" type="submit" className="bg-[#007CA1] text-white">
                    Submit
                  </Button>
                </div>
              </div>
            </form>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

const ContactUsPage = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
      <MainContent />
    </GoogleReCaptchaProvider>
  )
}

export default ContactUsPage;